import React from 'react';
import AccessControl from '../../components/common/AccessControl';
import AccessCodeArea from '../../components/hr/permissions/AccessCodeArea';
import ManageAccessCodes from '../../components/hr/permissions/ManageAccessCodes';

const Permissions: React.FC = () => (
    <React.Fragment>
        <div style={{paddingLeft: 20}} className="col-sm main-content d-flex flex-column">
            <AccessControl target="HR:EXEC">
                <ManageAccessCodes />
            </AccessControl>
            <AccessControl target="HR:ELEV">
                <AccessCodeArea />
            </AccessControl>
        </div>
    </React.Fragment>
);

export default Permissions;